import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import css from './TipoExamenSelector.module.css'

const TIPOS = [
  { value: 'ENUNCIADO', label: 'Enunciado' },
  { value: 'EXAMEN_RESUELTO', label: 'Examen resuelto' }
]

const TipoExamenSelector = ({ className, name, label, value, onChange }) => (
  <FormControl
    className={`${className} ${css.main}`}
    variant='standard'
    margin='dense'
    fullWidth
  >
    <InputLabel id={name}>{label}</InputLabel>
    <Select
      name={name}
      labelId={name}
      id={name}
      value={value}
      onChange={onChange}
      label={label}
    >
      {TIPOS.map(tipo => (
        <MenuItem key={tipo.value} value={tipo.value}>
          {tipo.label}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
)

export default TipoExamenSelector
